/**
 * Compile-time exhaustiveness guard for switch/if chains over a literal union. Call it in the
 * final branch after narrowing every known case — if a new union member is added without a
 * matching branch, `value` no longer narrows to `never` there and the build fails.
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled case: ${JSON.stringify(value)}`);
}
